import UPDATE_SCORE_COST from "../graphql/score_costs/update.gql";

import editableItems from "./editableItems";

export default {
  mixins: [editableItems],
  props: {
    scoreCosts: {
      type: Array,
      required: true
    },
    previsional: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      resourceName: "expense",
      updateMutation: UPDATE_SCORE_COST
    };
  },
  methods: {
    getEditedItem() {
      return {
        id: this.editedItem.id,
        currency_id: this.editedItem.currency_id,
        expedition_id: this.editedItem.expedition_id,
        change_rate: parseFloat(this.editedItem.change_rate),
        quantity: parseInt(this.editedItem.quantity),
        price_per_mt: parseFloat(this.editedItem.price_per_mt),
        percentage: parseFloat(this.editedItem.percentage),
        fixed_price: parseFloat(this.editedItem.fixed_price),
        unit_price: parseFloat(this.editedItem.unit_price),
        show_net_weight: this.editedItem.show_net_weight,
        show_price_per_mt: this.editedItem.show_price_per_mt,
        show_supplier_total_percentage: this.editedItem
          .show_supplier_total_percentage
      };
    },
    initItem() {
      return {
        id: "",
        currency_id: "",
        expedition_id: "",
        quantity: 0,
        unit_price: 0,
        fixed_price: 0,
        price_per_mt: 0,
        change_rate: 1,
        show_net_weight: false,
        show_price_per_mt: false,
        show_supplier_total_percentage: false
      };
    },
    optimistic() {
      let id = this.editedItem.id;
      let cur = this.currencies.find(e => e.id === this.editedItem.currency_id);

      var changes = {
        change_rate: parseFloat(this.editedItem.change_rate),
        quantity: parseInt(this.editedItem.quantity),
        price_per_mt: parseFloat(this.editedItem.price_per_mt),
        percentage: parseFloat(this.editedItem.percentage),
        fixed_price: parseFloat(this.editedItem.fixed_price),
        unit_price: parseFloat(this.editedItem.unit_price),
        currency_id: this.editedItem.currency_id,
        currency: {
          code: cur ? cur.code : "",
          name: cur ? cur.name : ""
        }
      };
      this.applyOptimistic(this.scoreCosts, id, changes);
    },
    setEditedItem(item) {
      this.editedItem = {
        id: item.id,
        currency_id: item.currency_id,
        expedition_id: item.expedition_id,
        change_rate: item.change_rate,
        quantity: item.quantity,
        price_per_mt: item.price_per_mt,
        percentage: item.percentage,
        fixed_price: item.fixed_price,
        unit_price: item.unit_price,
        show_net_weight: item.show_net_weight,
        show_price_per_mt: item.show_price_per_mt,
        show_supplier_total_percentage: item.show_supplier_total_percentage
      };
    },
    addCustomShowHeaders(headers) {
      if (this.scoreCosts[0].show_price_per_mt)
        headers.push({
          text: "Price per MT",
          align: "left",
          sortable: false,
          value: ""
        });

      if (this.scoreCosts[0].show_net_weight)
        headers.push({
          text: "Net Weight",
          align: "left",
          sortable: false,
          value: ""
        });

      if (this.scoreCosts[0].show_supplier_total_percentage)
        headers.push({
          text: "Supplier %",
          align: "left",
          sortable: false,
          value: ""
        });

      if (this.scoreCosts[0].show_customer_total_percentage)
        headers.push({
          text: "Customer %",
          align: "left",
          sortable: false,
          value: ""
        });
    },
    totalHeaders() {
      return [
        {
          text: "Total in current currency",
          shortText: "Tcc",
          align: "center",
          sortable: false,
          value: "total_cc"
        },
        {
          text: "Exchange Rate",
          shortText: "CR",
          align: "center",
          sortable: false,
          value: "change_rate"
        },
        {
          text: "Total in selling currency",
          shortText: "Tsc",
          align: "center",
          sortable: false,
          value: "total_sc"
        },
        {
          text: "Supplier",
          shortText: "Supp",
          align: "center",
          sortable: false,
          value: "supplier_company.name"
        }
      ];
    },
    actionHeaders() {
      return [
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: ""
        }
      ];
    },
    fetchHeaders() {
      let headers = this.specificHeaders();
      if (!this.previsional)
        headers = [
          {
            text: "Expedition Number",
            shortText: "Nb",
            align: "left",
            sortable: true,
            value: "expedition.number"
          }
        ].concat(headers);

      this.addCustomShowHeaders(headers);
      headers = headers.concat(this.totalHeaders());
      if (this.editable) headers = headers.concat(this.actionHeaders());
      return headers;
    },
    getHeaderTitle(header) {
      if (header.shortText) return header.shortText;
      return header.text;
    }
  }
};
